class PrintState {
  isPrinting: boolean;

  constructor() {
    this.isPrinting = false;

    const beforePrint = (): void => {
      this.isPrinting = true;
    };
    const afterPrint = (): void => {
      this.isPrinting = false;
    };

    window.addEventListener("beforeprint", beforePrint);
    window.addEventListener("afterprint", afterPrint);
  }

  triggerPrint(): void {
    // this is required because when triggering print with window.print() beforeprint is not run successfully
    this.isPrinting = true;
    setTimeout(window.print, 0);
  }
}

export const printState = new PrintState();
